import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LOGO_URL, ICON_URL, api, auth } from "@/lib/api";
import { toast } from "sonner";
import { LogIn, LayoutDashboard, Loader2 } from "lucide-react";

export default function Navbar() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const user = auth.getUser();

  const handleLogin = async (demo = false) => {
    setLoading(true);
    try {
      const { data } = await api.get(`/auth/discord/login${demo ? "?demo=true" : ""}`);
      if (data.mode === "demo") {
        auth.setSession(data.token, data.user);
        toast.success("Logged in (Demo Mode)");
        navigate("/dashboard");
      } else if (data.mode === "oauth") {
        // Break out of iframe (Emergent preview) — Discord blocks iframe embedding
        try { window.top.location.href = data.url; }
        catch { window.open(data.url, "_blank", "noopener"); }
      }
    } catch (e) {
      toast.error("Login failed: " + (e?.message || "unknown"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <nav
      data-testid="site-navbar"
      className="sticky top-0 z-50 border-b border-brand-line bg-black/85 backdrop-blur-md"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <a
          href="/"
          className="flex items-center gap-3"
          data-testid="navbar-home-link"
        >
          <img src={ICON_URL} alt="606" className="h-9 w-9 object-contain" />
          <div className="hidden sm:block">
            <div className="font-heading text-base font-bold uppercase tracking-tight leading-none">
              606 Community
            </div>
            <div className="font-mono-tabular text-[10px] text-brand-orange tracking-widest uppercase">
              GAMING · CONTROL CENTER
            </div>
          </div>
        </a>

        <div className="flex items-center gap-2">
          <a href="#features" className="btn-ghost hidden md:inline-flex" data-testid="nav-features">
            Features
          </a>
          <a href="#stats" className="btn-ghost hidden md:inline-flex" data-testid="nav-stats">
            Stats
          </a>
          <a href="#pricing" className="btn-ghost hidden md:inline-flex" data-testid="nav-pricing">
            Pricing
          </a>
          <a href="#join" className="btn-ghost hidden md:inline-flex" data-testid="nav-join">
            Join
          </a>

          {user ? (
            <button
              onClick={() => navigate("/dashboard")}
              className="btn-primary"
              data-testid="navbar-dashboard-btn"
            >
              <LayoutDashboard className="w-4 h-4" />
              Dashboard
            </button>
          ) : (
            <button
              onClick={() => handleLogin(false)}
              disabled={loading}
              className="btn-primary"
              data-testid="navbar-discord-login-btn"
            >
              {loading ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <LogIn className="w-4 h-4" />
              )}
              Login with Discord
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}
